import http from '@/http'
import { serializeObjectToQueryParameter } from '@/store/helper'

const API_PATH = 'link_preview/'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  async show(_, payload) {
    let data = null
    await http.get(API_PATH + serializeObjectToQueryParameter(payload)).then(response => {
      if (response.data.result === 'success') {
        data = response.data
      }
    }).catch(error => {
      console.error(error)
    })
    return data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
